const domain = process.env.ENV !== 'local' ? 'https://api.kahanchale.com/' : 'http://localhost:3001/'
export default domain
